import { render, staticRenderFns } from "./CRC_Tools.vue?vue&type=template&id=2d44d1f2&"
import script from "./CRC_Tools.vue?vue&type=script&lang=js&"
export * from "./CRC_Tools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports